import { useEffect } from 'react';
import { useIsAuthenticated, useDecodedToken } from 'mf_core/auth';
import { datadogRum } from '@datadog/browser-rum';

const isLocalDev = window.location.origin.indexOf('://local') > -1;

// Note: Datadog RUM initialization is handled in data-dog-rum.ts
export function useDatadog() {
  const isAuthenticated = useIsAuthenticated();
  const decodedToken = useDecodedToken();

  useEffect(() => {
    if (isAuthenticated && decodedToken && !isLocalDev) {
      datadogRum.setUser({
        email: decodedToken.email,
        id: decodedToken.userId,
        name: `${decodedToken.firstName} ${decodedToken.lastName}`,
      });
    }
  }, [isAuthenticated, decodedToken]);
}
